import { format } from 'date-fns';

export const splitFormattedDateTime = (isoString: string): { date: string; time: string } => {
  const date = new Date(isoString);

  if (isNaN(date.getTime())) {
    throw new Error('Invalid time value provided');
  }

  const datePart = format(date, 'dd-MM-yyyy');
  const timePart = format(date, 'HH:mm');

  return {
    date: datePart,
    time: timePart,
  };
};

export const formatFileType = (input: string): string =>
  input
    .toLowerCase()
    .replace(/_/g, ' ') // Replaces underscores with spaces
    .replace(/\b\w/g, (c) => c.toUpperCase()); // Capitalises the first letter of each word
